export const card: Style = ({
  // borderColor,
  size,
  radius,
  backgroundColor,
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: size.S,
  alignItems: 'stretch',
  textAlign: 'left',
  padding: size.S,
  borderRadius: radius.primary,
  backgroundColor: backgroundColor.card,
  userSelect: 'none',
  // border: `2px solid ${borderColor.secondary}`,
  boxShadow: `${backgroundColor.primary} 0px 8px 24px`,
})
